// Client mirror of the server booking rules (backend/booking_rules.py) for inline errors.
// The server remains authoritative; this only explains what is missing before submit.
export const normCategory = (cat) => {
  const c = (cat || "").toLowerCase();
  if (c.includes("vet") || c.includes("clinic")) return "vet";
  if (c.includes("board")) return "boarding";
  if (c.includes("daycare")) return "daycare";
  if (c.includes("train")) return "training";
  if (c.includes("groom")) return "grooming";
  return "other";
};

export const staffRequiredFor = (cats, requirements) =>
  [...new Set(cats)].filter((c) => requirements?.[c]?.requires_staff).sort();

export function bookingFormErrors({ customerId, productsOnly, selectedPets, emptyPets, staffCats, staffId, isBackdated, backdateReason }) {
  const errs = [];
  if (!customerId) errs.push({ field: "customer_id", msg: "Select a customer." });
  if (customerId && !productsOnly) {
    if (!selectedPets.length) errs.push({ field: "pets", msg: "Select at least one pet, or add products only." });
    else if (emptyPets.length) errs.push({ field: "services", msg: `Add at least one service for ${emptyPets.join(", ")}.` });
  }
  if (!productsOnly && staffCats.length && !staffId) errs.push({ field: "staff_id", msg: `A staff member is required for ${staffCats.join(", ")} bookings.` });
  if (isBackdated && !(backdateReason || "").trim()) errs.push({ field: "backdate_reason", msg: "Add a reason for backdating this appointment." });
  return errs;
}

export const needsRoom = (b) =>
  !b.resource_id && !["cancelled", "no_show", "completed"].includes(b.status)
  && ((b.services || []).some((s) => normCategory(s.category) === "boarding") || normCategory(b.booking_type) === "boarding");
